module.exports = __webpack_public_path__ + "static/img/c12.592dcac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c12.png
// module id = 259
// module chunks = 0 1 2 3 4 5 6 7 8 9